import { render, staticRenderFns } from "./DiscoverPage.vue?vue&type=template&id=5e6aa1f6"
import script from "./DiscoverPage.vue?vue&type=script&lang=js"
export * from "./DiscoverPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports